module.exports = __webpack_public_path__ + "img/DSC_9974-2.d69ee300.jpeg";